import { FieldModel } from '../extraction-models';
import { Validations } from '@ps-gui/ui';
import { FieldType } from '@ps-gui/shared-utils';

export const Kostentraeger = {
  kostentraeger_name: {
    key: 'kostentraeger_name',
    label: { text: 'Name', genus: 'M' },
    type: FieldType.STRING,
    index: 0,
  },
  kostentraeger_strasse: {
    key: 'kostentraeger_strasse',
    label: { text: 'Straße', genus: 'F' },
    type: FieldType.STRING,
    index: 1,
  },
  kostentraeger_hausnummer: {
    key: 'kostentraeger_hausnummer',
    label: { text: 'Hausnummer', genus: 'F' },
    type: FieldType.STRING,
    index: 2,
  },
  kostentraeger_postleitzahl: {
    key: 'kostentraeger_postleitzahl',
    label: { text: 'Postleitzahl', genus: 'F' },
    validators: [Validations.zip()],
    type: FieldType.STRING,
    index: 3,
  },
  kostentraeger_stadt: {
    key: 'kostentraeger_stadt',
    label: { text: 'Stadt', genus: 'F' },
    type: FieldType.STRING,
    index: 4,
  },
} satisfies Record<string, FieldModel>;
